angular.module('lf.common')

.directive('cartButton', function ($parse, i18n, gtmService) {
  var isMobileUI = lf.data.xhr.client.mobileUI;
  return {

    restrict: 'EA',

    scope: {
      cartItem: '&?'
    },

    controller: function ($scope, $injector, cartService, notificationService, gtmService) {
      $scope.add = function () {
        $scope.requesting = 'add';
        $scope.$emit('cart:requesting', true);
        
        cartService.add({product: $scope.product})
          .success(function (data) {
            data = data.data;
            if (data && (data.error || !data.success)) {
              var msg = (data.error.details && data.error.details.length > 0 ? data.error.details[0] : undefined);
              notifyError(msg);
            } else {
              gtmService.pushAddToCart($scope.product.gtmAttrs, $scope.product);

              $scope.added = true;
              if (isMobileUI) {
                notifySuccess(i18n.notify.addedToCartNotification, 'add');
              }
            }
          })
          .error(function (data) {
            notifyError();
          })
          .finally(function () {
            $scope.$emit('cart:requesting', false);
            delete $scope.requesting;
          });
      };
      
      $scope.changeQuantity = function () {
//        $scope.requesting = 'changeQuantity';

        if (angular.isUndefined($scope.product.updateQuantity)) {
          return;
        }
        
        $scope.$emit('cart:requesting', true);

        cartService.changeQuantity({product: $scope.product})
          .success(function (data) {
            var result = data.data;
            if (result && (result.error || !result.success)) {
              var msg = (result.error.details && result.error.details.length > 0 ? result.error.details[0] : undefined);
              notifyError(msg);
              $scope.product.updateQuantity = $scope.product.quantity;
            } else {
              gtmService.pushChangeCartQuantity({'oldQty': $scope.product.quantity, 'newQty' : parseInt($scope.product.updateQuantity)}, $scope.product);

              //$scope.added = true;
              if (isMobileUI) {
                //notifySuccess(i18n.notify.addedToCartNotification, 'add');
              }
            }
          })
          .error(function (data) {
            notifyError();
          })
          .finally(function () {
            //delete $scope.requesting;
            $scope.$emit('cart:requesting', false);
          });
      };

      $scope.remove = function () {
        $scope.requesting = 'remove';
        $scope.$emit('cart:requesting', true);

        cartService.remove({product: $scope.product})
          .success(function (data) {
            if (data.data && (data.data.error || !data.data.success)) {
              notifyError();
            } else {
              gtmService.pushRemoveFromCart($scope.product.gtmAttrs, $scope.product);

              $scope.removed = true;
              if (isMobileUI) {
                notifySuccess(i18n.notify.removedFromCart, 'remove');
              }
            }
          })
          .error(function (data) {
            notifyError();
          })
          .finally(function () {
            $scope.$emit('cart:requesting', false);
            delete $scope.requesting;
          });
      };
      
      function notifySuccess (msg, action) {
        var actionClass = '';

        switch(action) {
          case 'add':
            actionClass = 'fa-shopping-cart';
            break;
          case 'remove':
            actionClass = 'fa-times';
            break;
        }

        notificationService.show({
          text: '<i class="fa ' + actionClass + '"></i>' + $scope.product.title + ' <b>' + msg + '</b>'
        });
      };
      
      function notifyError (msg) {
        if (msg) {
          msg = '<b class="b-red">' + msg + '</b>';
        }
        if (isMobileUI) {
          notificationService.show({
            text: msg || ('<b class="b-red">' + i18n.notify.generalErrorTitle + '</b><br>' + i18n.notify.generalErrorText),
            error: true
          });
        } else {
          var popupsService = $injector.get('popupsService');
          var errorMessage = msg || ('<b>' + i18n.notify.generalErrorTitle + '</b><br />' +
                             i18n.notify.generalErrorText);
          popupsService.showError(errorMessage);
        }
      };
      
    },
    
    link: function (scope, el, attrs) {
      var product = scope.cartItem() || {
        id: attrs.productId,
        skuId: attrs.productSkuId,
        siteId: attrs.siteId,
        cartItemId: attrs.cartItemId,
        title: (attrs.productTitle || '').replace(/(^\s+|\s+$)/g, '')
      }
      
      var defaults = {
        classNameOnRequest: 'btn-cart_requesting',
        classNameOnAdd: 'btn-cart_added',
        disableOnRequest: true,
        disableOnAdd: true,
        changeTextOnRequest: isMobileUI,
        changeTextOnAdd: true
      }
      
      var options = $parse(attrs.cartButtonOptions)(scope.$parent);
      
      var opts = $.extend({}, defaults, options);

      var $productPod = el.closest('div.product-pod');

      if ($productPod.length) {
        product['gtmAttrs'] = gtmService.getParams($productPod);
      } else {
        gtmService.getClosestLocation(el, product);

        if(attrs.gaResultposition) {
            product['resPosition'] = attrs.gaResultposition;
        } else {
            var $itemContainer = el.closest('div.catalog-product');
            product['resPosition'] = ($itemContainer.parent().find('div.catalog-product').index($itemContainer) + 1);
        }
      }

      var button = {
        text: el.html()
      }
      
      scope.product = product;
      
      var clickEvent = 'click'; //el.parents('[scrollable]').length ? 'tap' : 'click';
      
      el.on(clickEvent, function () {
        scope[attrs.cartButton]();
      });
      
      scope.$watch('requesting', function (requesting) {
        var classify = (requesting ? 'add' : 'remove') + 'Class';
        el[classify](opts.classNameOnRequest);

        if (opts.disableOnRequest) {
          el.prop('disabled', !!requesting);
        }
        
        if (opts.changeTextOnRequest) {
          var text = {
            'add': (i18n.notify.addingToCart + '...'),
            'remove': (i18n.notify.removingFromCart + '...')
          }[requesting] || button.text;
          el.html(text);
        }
      });
      
      scope.$watch('added', function (added) {
        if (!added) return;
        var classify = (added ? 'add' : 'remove') + 'Class';
        el[classify](opts.classNameOnAdd);

        if (opts.disableOnAdd) {
          el.prop('disabled', true);
        }
        
        if (opts.changeTextOnAdd) {
          el.html(i18n.notify.addedToCart);
        }
      });
      
//      if (isMobileUI) {
//        scope.$watch('requesting', function (requesting) {
//          var classify = (requesting ? 'add' : 'remove') + 'Class';
//          el[classify]('btn-cart-requesting');
//          el.attr('disabled', !!requesting);
//        });
//        
//        scope.$watch('added', function (added) {
//          if (!added) return;
//          var classify = (added ? 'add' : 'remove') + 'Class';
//          el[classify]('btn-cart-added');
//          el.html(added ? i18n.notify.addedToCart : button.text);
//          el.attr('disabled', added);
//          opts.disableOnRequest = false;
//        });
//      }
//      
//      scope.$watch('requesting', function (requesting) {
//        el.html(requesting ? (requesting === 'add' ? i18n.notify.addingToCart : i18n.notify.removingFromCart) + '...' : button.text);
//        if (requesting) {
//          if (opts.classNameOnRequest) {
//            el.addClass(opts.classNameOnRequest)
//          }
//          if (opts.disableOnRequest) {
//            el.prop('disabled', true);
//          }
//        } else {
//          if (opts.classNameOnRequest) {
//            el.removeClass(opts.classNameOnRequest)
//          }
//          if (opts.disableOnRequest) {
//            el.prop('disabled', null);
//          }
//        }
//      });
      
      scope.$on('$destroy', function () {
        el.off(clickEvent);
      });
      
    }
  }
});
